import { Link } from 'react-router-dom';

/**
 * props:
 * - colSpan: number of columns of the host table
 * - title: short domain-specific message
 * - description: optional supporting text
 * - actionLabel: label of the primary action button
 * - onAction: click handler (reuses the screen's existing create flow)
 * - actionAttrs: extra button attributes (e.g. Bootstrap data-bs-toggle/target)
 * - canCreate: when false, hides the primary action (e.g. plan gating)
 * - showOnboardingLink: renders a link to the Getting Started guide (default true)
 */
function EmptyState(props) {
    const canCreate = props.canCreate !== false;
    const showOnboardingLink = props.showOnboardingLink !== false;

    return (
        <tr>
            <td colSpan={props.colSpan} className="text-center py-5">
                <h5 className="mb-2">{props.title}</h5>
                {props.description ? (
                    <p className="text-gray-700 mb-3">{props.description}</p>
                ) : null}
                {canCreate && props.actionLabel ? (
                    <button
                        type="button"
                        className="btn btn-primary animate-up-2 mb-3"
                        onClick={props.onAction}
                        {...(props.actionAttrs || {})}
                    >
                        {props.actionLabel}
                    </button>
                ) : null}
                {showOnboardingLink ? (
                    <div>
                        <Link to="/onboarding">
                            Follow the Getting Started guide
                        </Link>
                    </div>
                ) : null}
            </td>
        </tr>
    );
}

export default EmptyState;
